import axios from 'axios';

const state = {
  users: [],
  onlineUsers: [],
  error: null
};

const mutations = {
  setUsers(state, users) {
    state.users = users;
  },
  setOnlineUsers(state, onlineUsers) {
    state.onlineUsers = onlineUsers;
  },
  setError(state, error) {
    state.error = error;
  },
  clearError(state) {
    state.error = null;
  }
};

const actions = {
  async fetchUsers({ commit }) {
    try {
      const response = await axios.get('/api/admin/users');
      commit('setUsers', response.data.users);
      commit('clearError');
    } catch (error) {
      console.error('Error fetching users:', error);
      commit('setError', error.response ? error.response.data.message : error.message);
    }
  },
  async updateUserRole({ dispatch, commit }, { userId, role }) {
    try {
      await axios.patch(`/api/admin/users/${userId}`, { role });
      dispatch('fetchUsers');
    } catch (error) {
      console.error('Error updating user role:', error);
      commit('setError', error.response ? error.response.data.message : error.message);
    }
  },
  async deleteUser({ dispatch, commit }, userId) {
    try {
      await axios.delete(`/api/admin/users/${userId}`);
      dispatch('fetchUsers');
    } catch (error) {
      console.error('Error deleting user:', error);
      commit('setError', error.response ? error.response.data.message : error.message);
    }
  }
};

const getters = {
  users: state => state.users,
  onlineUsers: state => state.onlineUsers,
  error: state => state.error
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
